export const skeletalEquipmentSkins = {
  patched_cloth_armor: ["chest", "torso", "upper_arm_l", "forearm_l", "upper_arm_r", "forearm_r"],
  rough_leather_vest: ["chest", "torso"],
  wolfhide_jerkin: ["chest", "torso", "upper_arm_l", "forearm_l", "upper_arm_r", "forearm_r"],
  gnawmarked_greaves: ["pelvis", "thigh_l", "shin_l", "thigh_r", "shin_r"],
  salt_vein_greaves: ["pelvis", "thigh_l", "shin_l", "thigh_r", "shin_r"],
  wolfstep_boots: ["shin_l", "shin_r", "foot_l", "foot_r"],
  moonhide_mantle: ["chest", "upper_arm_l", "upper_arm_r"],
  rain_singer_cloak: ["chest", "upper_arm_l", "forearm_l", "upper_arm_r", "forearm_r"],
};

const equipmentSlotPriority = {
  body: 10,
  legs: 20,
  feet: 30,
  shoulders: 40,
};

export function skeletalEquipmentSkinPath(itemId) {
  return `/static/assets/player/skeleton/equipment-skins/${itemId}/atlas.json?v=equipment-skins-1`;
}

export function sortEquipmentForSkinning(equipment) {
  return [...equipment].sort((left, right) => {
    const priority = Number(equipmentSlotPriority[left?.slot] || 0) - Number(equipmentSlotPriority[right?.slot] || 0);
    return priority || String(left?.item_id || "").localeCompare(String(right?.item_id || ""));
  });
}
